import React from 'react';
import { Card, Tag } from 'antd';
import DarwinTypography from 'components/darwin-ui/Typography';
import { useTranslation } from 'react-i18next';
import { DarwinFlex } from 'components/darwin-ui';
import styles from './ErrorDetails.module.css';
import { MassiveDetailsType } from 'types/massiveTransactionTypes';

type Status = 'success' | 'warning' | 'error' | 'undefined';

const statusColor: Record<Status, string> = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  undefined: 'default',
};

interface Props {
  data: MassiveDetailsType;
  status: { label: string; type: Status };
}

export const ProcessSummary: React.FC<Props> = ({ data, status }) => {
  const { t } = useTranslation();
  return (
    <>
      <DarwinFlex style={{ width: '100%' }}>
        <Card
          size="small"
          style={{ borderBottomLeftRadius: 8, borderTopLeftRadius: 8 }}
          className={styles.cardStylus}
        >
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.upload-date')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.uploadDate}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>
        <Card size="small" className={styles.cardStylus}>
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.end-date')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.endDate}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>
        <Card size="small" className={styles.cardStylus}>
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.process')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.process}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>
        <Card size="small" className={styles.cardStylus}>
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.form-name')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.formName}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>
        <Card size="small" className={styles.cardStylus}>
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.process-map-name')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.processMapName}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>
        <Card size="small" className={styles.cardStylus}>
          <DarwinFlex vertical className={styles.cardContainer}>
            <DarwinTypography.Text className={styles.titleCard}>
              {t('error-details.card-section.file-name')}
            </DarwinTypography.Text>

            <DarwinTypography.Text className={styles.regularTextCard}>
              {data?.fileName}
            </DarwinTypography.Text>
          </DarwinFlex>
        </Card>

        {status && (
          <Card
            size="small"
            style={{ borderBottomRightRadius: 8, borderTopRightRadius: 8 }}
            className={styles.cardStylus}
          >
            <DarwinFlex vertical className={styles.cardContainer}>
              <DarwinTypography.Text className={styles.titleCard}>
                {t('error-details.card-section.status')}
              </DarwinTypography.Text>
              <Tag
                color={statusColor[status.type]}
                style={{
                  fontWeight: 600,
                  borderRadius: 8,
                  border: 'none',
                  width: 'fit-content',
                }}
              >
                {status.label}
              </Tag>
            </DarwinFlex>
          </Card>
        )}
      </DarwinFlex>
    </>
  );
};
